import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCarBrands, postCarBrand } from "../../app/services/carBrandService";
import { useAppDispatch } from "../../app/hooks";
import { useAccount, useMsal } from "@azure/msal-react";

import Form from "react-bootstrap/Form";
import { Alert, Breadcrumb, Button, Col, Row } from "react-bootstrap";
import {
  BrandDiscount,
  defaultBrandDiscount,
} from "../../models/responses/brandDiscount";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { postBrandDiscount } from "../../app/services/brandDiscountService";

interface Props {}

const BrandDiscountAdd: FC<Props> = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [displayError, setDisplayError] = useState(false);
  const isWaitingBrandDiscountPostResponse = useSelector(
    (state: RootState) => state.brandDiscount.isWaitingBrandDiscountPostResponse
  );
  const carBrands = useSelector(
    (state: RootState) => state.carBrand.carBrandList || []
  );
  const clientType = useSelector(
    (state: RootState) => state.clientType.clientType
  );
  const [brandDiscountData, setBrandDiscountData] =
    useState<BrandDiscount>(defaultBrandDiscount);

  useEffect(() => {
    dispatch(getCarBrands(instance, account));
  }, [account, accounts, dispatch, instance]);

  const workshopSalesDiscountInputHandler = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    let value = e.target.value.replace(",", ".");
    if (value.startsWith("0") && !value.includes("."))
      value = value.substring(1);

    setBrandDiscountData({
      ...brandDiscountData,
      workshopSalesDiscount: value,
    });
  };

  const storeDiscountInputHandler = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setBrandDiscountData({
      ...brandDiscountData,
      storeDiscount: e.target.value,
    });
  };

  const handleAddBrandDiscount = () => {
    setDisplayError(false);
    dispatch(
      postBrandDiscount(instance, account, brandDiscountData, onSuccess)
    );
  };

  const onSuccess = (brandDiscountId: string | null) => {
    if (brandDiscountId === null) {
      setDisplayError(true);
      return;
    }

    setTimeout(() => {
      navigate(`../${brandDiscountId}`, { relative: "path" });
    }, 500);
  };

  return (
    <div>
      <Breadcrumb>
        <Breadcrumb.Item href="/brand-discounts">Rabatter</Breadcrumb.Item>
        <Breadcrumb.Item active>Ny rabatt</Breadcrumb.Item>
      </Breadcrumb>
      <hr />
      <Form className="w-3">
        <Row>
          <Col xs={12} md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Bilmärke *</Form.Label>
              <Form.Select
                aria-label="Bilmärke"
                value={brandDiscountData.carBrandId || ""}
                onChange={(e) =>
                  setBrandDiscountData({
                    ...brandDiscountData,
                    carBrandId: e.target.value,
                  })
                }
              >
                <option value="">Välj bilmärke</option>{" "}
                {/* Ny default option */}
                {carBrands.map((carBrand) => (
                  <option key={carBrand.id} value={carBrand.id}>
                    {carBrand.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col xs={12} md={4}>
            <Form.Group className="mb-3">
              <Form.Label>VSN *</Form.Label>
              <Form.Control
                type="text"
                value={brandDiscountData.workshopSalesDiscount}
                onInput={workshopSalesDiscountInputHandler}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={4}>
            <Form.Group className="mb-3">
              <Form.Label>SPN *</Form.Label>
              <Form.Control
                type="text"
                value={brandDiscountData.storeDiscount}
                onInput={storeDiscountInputHandler}
              />
            </Form.Group>
          </Col>
        </Row>

        <div className="text-end">
          <Button
            variant="primary"
            className="mb-3"
            onClick={handleAddBrandDiscount}
            disabled={
              !(
                brandDiscountData.carBrandId !== undefined &&
                brandDiscountData.carBrandId.length > 0 &&
                !isWaitingBrandDiscountPostResponse
              )
            }
          >
            Lägg till rabatt
          </Button>
        </div>

        <Alert key="alert" variant="danger" show={displayError}>
          <p>Något gick fel, kontrollera uppgifterna och försök igen.</p>
        </Alert>
      </Form>
    </div>
  );
};

export default BrandDiscountAdd;
